// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TypesClusterMemberStatus
 */
export interface TypesClusterMemberStatus {
  /**
   *
   * @type {boolean}
   * @memberof TypesClusterMemberStatus
   */
  healthy?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TypesClusterMemberStatus
   */
  inRaftGroup?: boolean;
  /**
   *
   * @type {string}
   * @memberof TypesClusterMemberStatus
   */
  leader?: string;
  /**
   *
   * @type {string}
   * @memberof TypesClusterMemberStatus
   */
  memberId?: string;
  /**
   *
   * @type {boolean}
   * @memberof TypesClusterMemberStatus
   */
  recentContactWithLeader?: boolean;
}

/**
 * Check if a given object implements the TypesClusterMemberStatus interface.
 */
export function instanceOfTypesClusterMemberStatus(
  value: object,
): value is TypesClusterMemberStatus {
  return true;
}

export function TypesClusterMemberStatusFromJSON(
  json: any,
): TypesClusterMemberStatus {
  return TypesClusterMemberStatusFromJSONTyped(json, false);
}

export function TypesClusterMemberStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesClusterMemberStatus {
  if (json == null) {
    return json;
  }
  return {
    healthy: json['Healthy'] == null ? undefined : json['Healthy'],
    inRaftGroup: json['InRaftGroup'] == null ? undefined : json['InRaftGroup'],
    leader: json['Leader'] == null ? undefined : json['Leader'],
    memberId: json['MemberId'] == null ? undefined : json['MemberId'],
    recentContactWithLeader:
      json['RecentContactWithLeader'] == null
        ? undefined
        : json['RecentContactWithLeader'],
  };
}

export function TypesClusterMemberStatusToJSON(
  json: any,
): TypesClusterMemberStatus {
  return TypesClusterMemberStatusToJSONTyped(json, false);
}

export function TypesClusterMemberStatusToJSONTyped(
  value?: TypesClusterMemberStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    Healthy: value['healthy'],
    InRaftGroup: value['inRaftGroup'],
    Leader: value['leader'],
    MemberId: value['memberId'],
    RecentContactWithLeader: value['recentContactWithLeader'],
  };
}
